import React, { Component } from 'react';
import {Button} from 'react-bootstrap';
import DataGrid from '../common_components/DataGrid.js';
import {getAPI, convertTimestampToDate, getLoggedInUser} from '../common_components/common.js';
import Config from '../Config';
const { Translate } = require('react-i18nify');

export default class Video extends Component {
	constructor(props) {
		super(props);
		this.state = {
			apiUrl: Config.baseURL + 'videos/list',
			columns: [
				<Translate value='components.settings.Name' />,
				<Translate value='components.settings.URL' />,
			],
			fields: ['videoName', 'videoURL'],
			formatColumns: {5: {'link': {'column': 'videoURL'}}},
			data: [],
			offset: 0,
			limit: 2500,
			showNewShipperForm: false,
			editShipperId: null,
			loading: true,
			autoRefresh: true,
			interval: null,
		};
	}

	refreshData() {
		this.setState({loading: true});
		/*
		getAPI("shippers/list").then(resShippers => {
			this.setState({
				data: resShippers['data'],
				loading: false,
			});
		});
		*/
		this.setState({
			data: [{
				'videoName': 'Beginning Press Side Training Video', 
				'videoURL': 'https://bcminks-assets.s3.us-east-2.amazonaws.com/training/videos/online_presentation.wmv'
				}],
			loading: false,
		});
	}

	componentDidMount() {
		this.refreshData();	
		
		const interval = setInterval(async () => {
			if(this.state.autoRefresh && !this.state.showNewShipperForm) {
				this.refreshData();	  
			}
		}, Config.keepConnInterval);
		this.setState({interval: interval});
	}
	
	componentWillUnmount() {
		clearInterval(this.state.interval);
	}
	
	render() {
		const loggedInUser = getLoggedInUser();
		let data = this.state.data;
		// Global Search
		if(this.props.search) {
			data = data.filter(obj => {
				const strSearchString = this.state.fields.map((field, i) => { 
					return this.state.formatColumns[i] && this.state.formatColumns[i]['date'] ? 
						convertTimestampToDate(obj[field]) : obj[field];
				}).join("~").toLowerCase();
				return strSearchString.indexOf(this.props.search.toLowerCase()) !== -1;
			});
		}
		
		return (
			<table class="table table-striped table-hover data-grid" style={{width: "90%"}}>
				<thead>
					<tr class="data-grid-row">
						<th class="data-grid-header">
							<div id="id">
								<div class="col-md-12">
									<div class="row"><span><span>Name</span></span>&nbsp;</div>
								</div>
							</div>
						</th>
						<th class="data-grid-header">
							<div id="orderDate">
								<div class="col-md-12">
									<div class="row"><span><span>URL</span></span>&nbsp;</div>
								</div>
							</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr class="data-grid-row">
						<td style={{"vertical-align":"middle", "font-size": "16px"}}>Beginning Press Side Training Video (EN)</td>
						<td>
							<a target="__blank" href="https://bcminks-assets.s3.us-east-2.amazonaws.com/training/videos/online_presentation.wmv">
								<img width="160px" height="80px" src="https://bcminks-assets.s3.us-east-2.amazonaws.com/training/videos/bcm+training+1.png" />
							</a>
						</td>
					</tr>
					<tr class="data-grid-row">
						<td style={{"vertical-align":"middle", "font-size": "16px"}}>Ink Kitchen Best Practices Video (EN)</td>
						<td>
							<a target="__blank" href="https://bcminks-assets.s3.us-east-2.amazonaws.com/training/videos/Edited_Ink%20Kitchen.mp4.mp4">
								<img width="160px" height="80px" src="https://bcminks-assets.s3.us-east-2.amazonaws.com/training/videos/ink+kitchen+best+practices+1.png" />
							</a>
						</td>
					</tr>
				</tbody>
			</table>
		);
	}
}
